import { render, staticRenderFns } from "./BaseTable.vue?vue&type=template&id=1be5fe5b&scoped=true&functional=true"
import script from "./BaseTable.vue?vue&type=script&lang=js"
export * from "./BaseTable.vue?vue&type=script&lang=js"
import style0 from "./BaseTable.vue?vue&type=style&index=0&id=1be5fe5b&prod&scoped=true&lang=css"
import style1 from "./BaseTable.vue?vue&type=style&index=1&id=1be5fe5b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "1be5fe5b",
  null
  
)

export default component.exports